import {
  updateParcel,
  parcelSelector,
  isMultiboxSelector,
  ADDITIONAL_DEPENDENT_PROPERTIES,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {getState, useSelector} from '../../../store.js'
import {UPS} from '../../../common/constants/ShipperNames.js'
import {DRY_ICE_WEIGHT, LABEL_PROPERTY_DRY_ICE_WEIGHT} from './DryIceWeight.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const LABEL_PROPERTY = 'packages[0].dry_ice_regulation_set'
const VALID_SHIPPER_TYPES = [UPS]

const DRY_ICE_REGULATION_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_DRY_ICE_WEIGHT,
]

function dependentPropertiesFunc() {
  return DRY_ICE_REGULATION_DEPENDENT_PROPERTIES
}

function labelPropertiesFunc(shipperType, labelInfoID) {
  let {[DRY_ICE_WEIGHT]: dryIceWeight} = parcelSelector(getState(), {
    labelInfoID,
    packagesIndex: 0,
  })

  dryIceWeight = Number(dryIceWeight) || 0

  return dryIceWeight > 0 ? [LABEL_PROPERTY] : []
}

export default function DryIceRegulationSet({packagesIndex}) {
  packagesIndex = packagesIndex || 0
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DryIceRegulationSet.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  let {
    dry_ice_regulation_set: dryIceRegulationSet,
    [DRY_ICE_WEIGHT]: dryIceWeight,
  } = useSelector((state) =>
    parcelSelector(state, {labelInfoID, packagesIndex}),
  )
  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID, shipperType}),
  )

  dryIceWeight = Number(dryIceWeight) || 0

  return (
    <ConfigSelect
      label="Dry Ice Regulation"
      value={dryIceRegulationSet || ''}
      onChange={(value) => {
        updateParcel(labelInfoID, packagesIndex, {
          dry_ice_regulation_set: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="dry_ice_regulation_set"
      noEmptyOption
      hide={isMultibox || dryIceWeight <= 0}
    />
  )
}

DryIceRegulationSet.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
  },
]
